/* Collection of Existing Routes */
export const sideBarLink = [
    { path: '/dashboard/summary', icon: 'fas fa-square', name: 'Summary' },
    { path: '/dashboard/create-user', icon: 'fas fa-plus', name: 'Create Users' },
    { path: '/dashboard/manager-users', icon: 'fas fa-users-cog', name: 'Managers' },
    { path: '/dashboard/users', icon: 'fas fa-users', name: 'Users' },
    //{ path: '/dashboard/active-users', icon: 'fas fa-users', name: 'Active Users' },
    //{ path: '/dashboard/admin-users', icon: 'fas fa-user-shield', name: 'Admin Users' },
    { path: '/dashboard/transactions', icon: 'fas fa-money-check-alt', name: 'Transactions' },
    { path: '/dashboard/vouchers', icon: 'fas fa-gift', name: 'Vouchers' },
    { path: '/dashboard/licenses', icon: 'fas fa-id-card', name:'Licenses'}
]